import React, { useState } from "react";
import AuthProvider from "../../auth/AuthProvider";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import Algemeen from "./Tabs/Algemeen";
import Branding from "./Tabs/Branding";
import Customfields from "./Tabs/Customfields";
import Registration from "./Tabs/Registration";
import Printers from "./Tabs/Printers";
import Serviceverzoeken from "./Tabs/Serviceverzoeken";
import Overige from "./Tabs/Overige";
import Zuil from "./Tabs/Zuil";
import Allyoucaneat from "./Tabs/Allyoucaneat";
import Preordering from "./Tabs/Preordering.tsx";
import Keukenscherm from "./Tabs/Keukenscherm";
import CustomButton from "./Tabs/Custombutton";
//import Arrangementen from "./Tabs/Arrangementen";    //this tab is temporarily disabled
import Primairbetallingsverkeer from "./Tabs/Primairbetallingsverkeer";
import Beveiliging from "./Tabs/Beveiliging";
import DeliverySettings from "./Tabs/DeliverySettings";
import Upsell from "./Tabs/Upsell";
import Berichten from "./Tabs/Berichten";
import Mail from "./Tabs/Mail";
import Betweenorder from "./Tabs/Betweenorder.tsx";
import CustomExports from "./Tabs/CustomExports";
import Piggy from "./Tabs/Api/Piggy";
import Mrwinston from "./Tabs/Api/Mrwinston";
import Untill from "./Tabs/Api/Untill";
import Vectron from "./Tabs/Api/Vectron";
import Bork from "./Tabs/Api/Bork";
import Ecash from "./Tabs/Api/Ecash";
import BlackBox from "./Tabs/BlackBox/BlackBox";
import Lightspeed from "./Tabs/Api/Lightspeed";
import LigthspeedK from "./Tabs/Api/LightspeedK";
import MplusAPI from "./Tabs/Api/MplusAPI";
import Twelve from "./Tabs/Api/Twelve";
import Aloha from "./Tabs/Api/Aloha";
import AlohaAllermap from "./Tabs/Api/AlohaAllermap";
import Cashdesk from "./Tabs/Api/Cashdesk";
import Gastrofix from "./Tabs/Api/Gastrofix";
import Simphony from "./Tabs/Api/Simphony";
import Micros3700 from "./Tabs/Api/Micros3700";
import Nuvopos from "./Tabs/Api/Nuvopos";
import Greatpos from "./Tabs/Api/Greatpos";
import Clubplanner from "./Tabs/Api/Clubplanner";
import Service from "./Tabs/Api/Service";
import VestigingProvider from "../../components/Forms/VestigingProvider";
import Qr from "./Tabs/Qr";
import PickupDelivery from "./Tabs/PickupDelivery";
import Tablet from "./Tabs/Tablet.tsx";
import Taurus from "./Tabs/Api/Taurus";
import Tweakwise from "./Tabs/Api/Tweakwise";
import { formatTitle } from "../../../utils/formatting";
import Boomi from "./Tabs/Api/Boomi";
import Media from "./Tabs/Media";
import PosSync from "./Tabs/Api/PosSyncs/PosSync";
import Proppos from "./Tabs/Proppos";
import MWise from "./Tabs/Api/MWise";

import Arrangements from "./Tabs/Arrangements/Arrangements";
import { useFormContext } from "react-hook-form";
import Webhooks from "./Tabs/Webhooks/Webhooks";
import { Salesarea } from "../../../../../appv5/src/types/shared/Salesarea";
import { useSwitchToSalesarea } from "./UseSwitchToSalesarea";
import MultiAreaSync from "./Tabs/MultiAreaSync";
import Deliverect from "./Tabs/Api/Deliverect";
import { useParams } from "react-router";
import Eds from "./Tabs/Api/Eds/Eds";
import { SalesareaProvider } from "../Upsell/modernTS/salesarea/SalesareaContext";
import CustomData from "./Tabs/Api/CustomData";

function VestigingForm(props) {
  const params = useParams();
  const [menukaartVestigingId, setMenukaartVestigingId] = useState(params?.id);
  const [vestigingId, setVestigingId] = useState(params?.id);
  const [vestiging, setVestiging] = useState<Salesarea | null>(null);

  // should be hidden when menukaart is a reference.
  // Syncing makes no sense for references
  const mkv = vestiging?.menukaartVestiging;
  const shouldShowApiSync = mkv === 0 || mkv === null || mkv === undefined || mkv === "0";

  useSwitchToSalesarea(vestiging);

  let serviceApiData: Tab[] = [];
  if (shouldShowApiSync) {
    serviceApiData = [
      {
        right: "api",
        tabButton: <TranslationWrapper tDefault={"Service API Data"} tKey={"vestigingen.form.tabs.serviceApiData"} />,
        tabContent: <Service />,
        key: "service api data old",
      },
      {
        right: "api",
        tabButton: <TranslationWrapper tDefault={"SyncV2 Logs"} tKey={"vestigingen.form.tabs.serviceApiDataNew"} />,
        tabContent: <PosSync />,
        key: "SyncV2 Logs",
      },
    ];
  }

  return (
    <AuthProvider prefix={"vestigingen"}>
      <VestigingProvider vestiging={vestiging}>
        <SalesareaProvider salesareaId={vestiging?.id}>
          <JamezzFormV2
            key={params?.id}
            computedPageTitle={function (model) {
              return formatTitle(this.pageTitle, model.systeemNaam);
            }}
            customFieldSerialization={{
              eds_connection__composed_id_mapping: (o) =>
                typeof o !== "string" ? JSON.stringify(o) : JSON.stringify(o),
              apiaccounts__dojo: (o) => {
                return typeof o !== "string" ? JSON.stringify(o) : o;
              },
            }}
            endPoint={"core/vestigingen"}
            extraFormProps={{ menukaartVestigingId, vestigingId, vestiging }}
            onGetModel={(model) => {
              if (model.extra_settings) {
                Object.keys(model.extra_settings).forEach((key) => {
                  model["extra_settings__" + key] = model.extra_settings[key];
                });
              }
              if (model.pickup_codes) {
                Object.keys(model.pickup_codes).forEach((key) => {
                  model["pickup_codes__" + key] = model.pickup_codes[key];
                });
              }
              if (model.delivery_settings) {
                Object.keys(model.delivery_settings).forEach((key) => {
                  model["delivery_settings__" + key] = model.delivery_settings[key];
                });
              }
              if (model.eds_connection) {
                Object.keys(model.eds_connection).forEach((key) => {
                  model["eds_connection__" + key] = model.eds_connection[key];
                });
              }
              if (model.payment_settings) {
                Object.keys(model.payment_settings).forEach((key) => {
                  model["payment_settings__" + key] = model.payment_settings[key];
                });
              }
              if (model.upsell_settings) {
                Object.keys(model.upsell_settings).forEach((key) => {
                  model["upsell_settings__" + key] = model.upsell_settings[key];
                });
              }
              if (model.time_settings) {
                Object.keys(model.time_settings).forEach((key) => {
                  model["time_settings__" + key] = model.time_settings[key];
                });
              }
              if (model.menu_auto_sync) {
                Object.keys(model.menu_auto_sync).forEach((key) => {
                  model["menu_auto_sync__" + key] = model.menu_auto_sync[key];
                });
              }
              if (model.images_auto_sync) {
                Object.keys(model.images_auto_sync).forEach((key) => {
                  model["images_auto_sync__" + key] = model.images_auto_sync[key];
                });
              }
              if (model.proppos_settings) {
                Object.keys(model.proppos_settings).forEach((key) => {
                  model["proppos_settings__" + key] = model.proppos_settings[key];
                });
              }

              if (model.pay_provider_sec) {
                let prefix = "";
                switch (model.pay_provider_sec_type) {
                  case "Gifty":
                    prefix = "gifty__";
                    break;
                  case "Piggy":
                    prefix = "piggy__";
                    break;
                  case "Ccv":
                    prefix = "ccv__";
                    break;
                  case "Cikam":
                    prefix = "cikam__";
                    break;
                }

                Object.keys(model.pay_provider_sec).forEach((key) => {
                  model["pay_provider_sec__" + prefix + key] = model.pay_provider_sec[key];
                });
              }
              if (model.keukenscherm) {
                Object.keys(model.keukenscherm).forEach((key) => {
                  model["keukenscherm__" + key] = model.keukenscherm[key];
                });
              }
              if (model.mpluscustomfieldsmap) {
                Object.keys(model.mpluscustomfieldsmap).forEach((key) => {
                  model["mpluscustomfieldsmap_" + model.mpluscustomfieldsmap[key].fieldname] =
                    model.mpluscustomfieldsmap[key].mapto;
                });
              }
              if (model.apiaccounts) {
                Object.keys(model.apiaccounts).forEach((key) => {
                  model["apiaccounts__" + key] = model.apiaccounts[key];
                });
              }
              if (model.volatile_salesarea_data) {
                Object.keys(model.volatile_salesarea_data).forEach((key) => {
                  model["volatile_salesarea_data__" + key] = model.volatile_salesarea_data[key];
                });
              }
              if (model.piggy) {
                Object.keys(model.piggy).forEach((key) => {
                  model["piggy__" + key] = model.piggy[key];
                });
              }
              if (model.media_urls) {
                Object.keys(model.media_urls).forEach((key) => {
                  if (model[key] == null) {
                    model[key] = 1;
                  }
                });
              }

              setMenukaartVestigingId(model.menukaartVestiging > 0 ? model.menukaartVestiging : params.id);
              setVestigingId(model.id ?? params.id);
              setVestiging(model);
            }}
            pageTitle={getTranslation("vestigingen.form.pageTitle", "Vestiging")}
            parseInput={{
              extra_settings__blinkstick_settings: (response) => JSON.parse(response),
              custom_component_styling: (response) => {
                return response ? JSON.parse(response) : null;
              },
              custom_data: (response) => {
                return response == "[]" ? {} : response ? JSON.parse(response) : {};
              },
              apiaccounts__deliverect_api_details: (response) => {
                return Array.isArray(response) && response.length === 0 ? {} : (response ?? {});
              },
              custom_fonts: (response) => {
                return response ? JSON.parse(response) : [];
              },
              img_uuids: (response) => {
                return response
                  ? JSON.parse(response).map((uuid) => ({
                      uuid: uuid,
                    }))
                  : [];
              },
              scheduled_homescreen_videos: (response) => {
                return response.map((r) => {
                  const [startTime, stopTime] = (r.opening_hours.rawData?.monday ?? r.opening_hours?.monday)[0].split(
                    "-"
                  );
                  return {
                    startTime,
                    stopTime,
                    id: r.id,
                    attached_media: r.homescreen_videos.video_or_image,
                  };
                });
              },
            }}
            parseOutput={{
              img_uuids: (img_uuid) => img_uuid,
              custom_component_styling: (object) => JSON.stringify(object),
              extra_settings__blinkstick_settings: (object) => JSON.stringify(object),
              custom_data: (o) => (typeof o !== "string" ? JSON.stringify(o) : o),
              apiaccounts__dojo: (o) => (typeof o !== "string" ? JSON.stringify(o) : o),
              apiaccounts__deliverect_api_details: (o) => (typeof o !== "string" ? JSON.stringify(o) : o),
              piggy__custom_data: (object) => JSON.stringify(object),
              time_settings__opening_hours: (object) => JSON.stringify(object),
              time_settings__preordering_hours: (object) => JSON.stringify(object),
              extra_settings__tip_configuration: (o) => {
                return JSON.stringify(o);
              },
            }}
            rootRight={"vestigingen"}
            tabs={[
              {
                right: "algemeen",
                tabButton: <TranslationWrapper tDefault={"Algemeen"} tKey={"vestigingen.form.tabs.algemeen"} />,
                tabContent: <Algemeen />,
              },
              {
                right: "algemeen",
                tabButton: <TranslationWrapper tDefault={"QR"} tKey={"vestigingen.form.tabs.qr"} />,
                tabContent: <Qr />,
              },
              {
                right: "algemeen",
                tabButton: (
                  <TranslationWrapper
                    tDefault={"Pickup Delivery Webshop"}
                    tKey={"vestigingen.form.tabs.pickupdelivery"}
                  />
                ),
                tabContent: <PickupDelivery />,
              },
              {
                right: "algemeen",
                tabButton: <TranslationWrapper tDefault={"Tablets"} tKey={"vestigingen.form.tabs.tablets"} />,
                tabContent: <Tablet />,
              },
              {
                right: "zuil",
                tabButton: <TranslationWrapper tDefault={"Kiosk"} tKey={"vestigingen.form.tabs.zuil"} />,
                tabContent: <Zuil />,
              },

              {
                right: "branding",
                tabButton: (
                  <TranslationWrapper tDefault={"Branding / Design"} tKey={"vestigingen.form.tabs.branding"} />
                ),
                tabContent: <Branding />,
              },
              {
                right: "customfields",
                tabButton: <TranslationWrapper tDefault={"Velden"} tKey={"vestigingen.form.tabs.customFields"} />,
                tabContent: <Customfields />,
              },
              // {
              //   right: "customfields",
              //   tabButton: <TranslationWrapper tKey={"vestigingen.form.tabs.customFields"} tDefault={"Velden"} />,
              //   tabContent: <CustomFieldsV5 />,
              // },
              {
                right: "registration",
                tabButton: <TranslationWrapper tDefault={"Registratie"} tKey={"vestigingen.form.tabs.registration"} />,
                tabContent: <Registration />,
              },
              {
                right: "printers",
                tabButton: <TranslationWrapper tDefault={"Printers"} tKey={"vestigingen.form.tabs.printers"} />,
                tabContent: <Printers />,
              },
              {
                right: "serviceverzoeken",
                tabButton: (
                  <TranslationWrapper tDefault={"Serviceverzoeken"} tKey={"vestigingen.form.tabs.serviceverzoeken"} />
                ),
                tabContent: <Serviceverzoeken />,
              },
              {
                right: "overige",
                tabButton: <TranslationWrapper tDefault={"Overige"} tKey={"vestigingen.form.tabs.overige"} />,
                tabContent: <Overige />,
              },
              {
                right: "multiAreaSync",
                tabButton: "MAPPS",
                tabContent: <MultiAreaSync />,
              },
              {
                right: "allyoucaneat",
                tabButton: (
                  <TranslationWrapper tDefault={"All you can eat"} tKey={"vestigingen.form.tabs.allYouCanEat"} />
                ),
                tabContent: <Allyoucaneat />,
              },
              {
                right: "preordering",
                tabButton: <TranslationWrapper tDefault={"Tijden"} tKey={"vestigingen.form.tabs.preOrdering"} />,
                tabContent: <Preordering />,
              },
              {
                right: "keukenscherm",
                tabButton: <TranslationWrapper tDefault={"Keukenscherm"} tKey={"vestigingen.form.tabs.keukenscherm"} />,
                tabContent: <Keukenscherm />,
              },
              {
                right: "custombutton",
                tabButton: (
                  <TranslationWrapper tDefault={"Custom button"} tKey={"vestigingen.form.tabs.customButton"} />
                ),
                tabContent: <CustomButton />,
              },
              {
                right: "arrangementen",
                tabButton: <TranslationWrapper tDefault={"Arrangements"} tKey={"vestigingen.form.tabs.arrangement"} />,
                tabContent: <Arrangements />,
              },
              {
                navigationKey: "payments",
                right: "primairbetalingsverkeer",
                tabButton: (
                  <TranslationWrapper tDefault={"Betalingen"} tKey={"vestigingen.form.tabs.betallingsverkeer"} />
                ),
                tabContent: <Primairbetallingsverkeer />,
              },

              {
                right: "autoreports",
                tabButton: <TranslationWrapper tDefault={"Beveiliging"} tKey={"vestigingen.form.tabs.beveiliging"} />,
                tabContent: <Beveiliging />,
              },
              {
                right: "deliverysettings",
                tabButton: (
                  <TranslationWrapper
                    tDefault={"Bezorg instellingen"}
                    tKey={"vestigingen.form.tabs.deliverySettings"}
                  />
                ),
                tabContent: <DeliverySettings />,
              },
              {
                right: "upsell",
                tabButton: <TranslationWrapper tDefault={"Upsell"} tKey={"vestigingen.form.tabs.upsell"} />,
                tabContent: <Upsell />,
              },
              {
                right: "berichten",
                tabButton: <TranslationWrapper tDefault={"Teksten"} tKey={"vestigingen.form.tabs.teksten"} />,
                tabContent: <Berichten />,
              },
              {
                right: "mail",
                tabButton: <TranslationWrapper tDefault={"Mail"} tKey={"vestigingen.form.tabs.mail"} />,
                tabContent: <Mail />,
              },
              {
                right: "betweenorder",
                tabButton: (
                  <TranslationWrapper tDefault={"Tussen ordersscherm"} tKey={"vestigingen.form.tabs.betweenorder"} />
                ),
                tabContent: <Betweenorder />,
              },
              {
                right: "customexports",
                tabButton: <TranslationWrapper tDefault={"Exports"} tKey={"vestigingen.form.tabs.customexports"} />,
                tabContent: <CustomExports />,
              },

              {
                right: "proppos",
                tabButton: <TranslationWrapper tDefault={"Proppos"} tKey={"vestigingen.form.tabs.proppos"} />,
                tabContent: <Proppos />,
              },
              {
                tabButton: <TranslationWrapper tDefault={"Media"} tKey={"vestigingen.form.tabs.media"} />,
                tabContent: <Media />,
              },
              {
                right: "api",
                tabButton: <TranslationWrapper tDefault={"Blackbox"} tKey={"vestigingen.form.tabs.blackbox"} />,
                tabContent: <BlackBox />,
              },
              {
                right: "webhooks",
                tabButton: <TranslationWrapper tDefault={"Webhooks"} tKey={"vestigingen.form.tabs.webhooks"} />,
                tabContent: <Webhooks />,
              },
              {
                right: "piggy",
                tabButton: (
                  <TranslationWrapper tDefault={"Piggy Loyalty"} tKey={"vestigingen.form.tabs.piggy.loyalty"} />
                ),
                tabContent: <Piggy />,
              },
              {
                right: "Mwise",
                tabButton: (
                  <TranslationWrapper tDefault={"Mwise Loyalty"} tKey={"vestigingen.form.tabs.mwise.loyalty"} />
                ),
                tabContent: <MWise />,
              },
              {
                right: "api",
                tabButton: <TranslationWrapper tDefault={"Mr winston"} tKey={"vestigingen.form.tabs.mrWinston"} />,
                tabContent: <Mrwinston />,
              },
              {
                right: "api",
                tabButton: <TranslationWrapper tDefault={"Untill"} tKey={"vestigingen.form.tabs.untill"} />,
                tabContent: <Untill />,
              },
              {
                right: "api",
                tabButton: <TranslationWrapper tDefault={"Vectron"} tKey={"vestigingen.form.tabs.vectron"} />,
                tabContent: <Vectron />,
              },
              {
                right: "api",
                tabButton: (
                  <TranslationWrapper tDefault={"Bork / Trivec Lite"} tKey={"vestigingen.form.tabs.borkTrivecLite"} />
                ),
                tabContent: <Bork />,
              },
              {
                right: "api",
                tabButton: <TranslationWrapper tDefault={"Lightspeed"} tKey={"vestigingen.form.tabs.lightspeed"} />,
                tabContent: <Lightspeed />,
              },
              {
                right: "api",
                tabButton: <TranslationWrapper tDefault={"Lightspeed K"} tKey={"vestigingen.form.tabs.lightspeedk"} />,
                tabContent: <LigthspeedK />,
              },
              {
                right: "api",
                tabButton: <TranslationWrapper tDefault={"Mplus API"} tKey={"vestigingen.form.tabs.mplusApi"} />,
                tabContent: <MplusAPI />,
              },
              {
                right: "api",
                tabButton: <TranslationWrapper tKey={"Twelve"} />,
                tabContent: <Twelve />,
              },
              {
                right: "api",
                tabButton: <TranslationWrapper tKey={"NCR Aloha (TIM)"} />,
                tabContent: <Aloha />,
              },
              {
                right: "api",
                tabButton: "NCR Aloha Allergeenmap",
                tabContent: <AlohaAllermap />,
              },
              {
                right: "api",
                tabButton: <TranslationWrapper tKey={"CashDesk"} />,
                tabContent: <Cashdesk />,
              },
              {
                right: "api",
                tabButton: <TranslationWrapper tKey={"Gastrofix"} />,
                tabContent: <Gastrofix />,
              },
              {
                right: "api",
                tabButton: <TranslationWrapper tKey={"Oracle Simphony"} />,
                tabContent: <Simphony />,
              },
              {
                right: "api",
                tabButton: "Micros 3700",
                tabContent: <Micros3700 />,
              },
              {
                right: "api",
                tabButton: <TranslationWrapper tKey={"Nuvopos"} />,
                tabContent: <Nuvopos />,
              },
              {
                right: "api",
                tabButton: "Greatpos",
                tabContent: <Greatpos />,
              },
              {
                right: "api",
                tabButton: "Clubplanner",
                tabContent: <Clubplanner />,
              },
              {
                right: "api",
                tabButton: "E-Cash",
                tabContent: <Ecash />,
              },
              {
                right: "api",
                tabButton: "Taurus",
                tabContent: <Taurus />,
              },
              {
                right: "api",
                tabButton: "Deliverect",
                tabContent: <Deliverect />,
              },
              {
                right: "api",
                tabButton: "Tweakwise",
                tabContent: <Tweakwise />,
              },
              {
                right: "api",
                tabButton: "Eds",
                tabContent: <Eds />,
              },
              {
                right: "api",
                tabButton: "Boomi",
                tabContent: <Boomi />,
              },
              ...serviceApiData,
              {
                right: "custom_data",
                tabButton: (
                  <TranslationWrapper tDefault={"View custom data"} tKey={"vestigingen.form.tabs.custom_data"} />
                ),
                tabContent: <CustomData />,
              },
            ]}
          />
        </SalesareaProvider>
      </VestigingProvider>
    </AuthProvider>
  );
}

export default VestigingForm;

export type VestigingFormContext = {
  vestigingId?: number;
  menukaartVestigingId?: number;
  vestiging?: any;
} & ReturnType<typeof useFormContext>;
